import {UserAuthItemTypeEnum} from "arteco-api-client-ts";
import {useAuthManager} from "../../../components/utils/auth";

/** Raíz del módulo de compliance (#13899). Aparte de las rutas para no importarlas en círculo. */
export const COMPLIANCE = "/app/admin/compliance";

const hasAny = (types: string[], ...wanted: UserAuthItemTypeEnum[]) => wanted.some(w => types.includes(w));

/** Quién ve cada parte del módulo, según sus roles (el API es quien manda; esto solo ordena el menú). */
export const useComplianceAccess = () => {
	const authManager = useAuthManager();
	const types = authManager.getAuthorities().map(a => a.type as string);
	return {
		/** El sistema de gestión entero: ADMIN o el rol de compliance. */
		full: hasAny(types, UserAuthItemTypeEnum.ADMIN, UserAuthItemTypeEnum.ADMIN_COMPLIANCE),
		/** RR. HH.: los documentos de empresa, y el enlace a formación y entrevistas. */
		hr: hasAny(types, UserAuthItemTypeEnum.ADMIN, UserAuthItemTypeEnum.ADMIN_EMPLOYEE),
	};
};
